// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { getRemarks, resetCreateVisitRemarkSuccess } from '../../store/visits/VisitsActions'
import { VisitsTableHeader } from './VisitsTableHeader'
import { VisitsTableContainer } from './VisitsTableContainer/VisitsTableContainer'
import { VisitRemarks } from './visit-remarks/VisitRemarks'
import './Visits.scss'
import { parseTimeZone } from '../../utils/common'

export const VisitsTable = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    visits,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    showRemarks,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setShowRemarks,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    visitsMode,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    noResults,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    dispatchFilter,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    stateFilter,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setVisitTypesFilterRow,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setStatusFilterRow,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    visitTypesFilterRow,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    statusFilterRow,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setTriggerTabId,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isNeedToUpdateFilterIcon,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setSelectedVisitId,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setStatusTagRow,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    tagFilterRow,
  }) => {
    const dispatch = useDispatch()
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const loading = useSelector((state) => state.visitsReducer.loading)
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const profile = useSelector((state) => state.accountSettings.adminProfile)

    const [userTimeZone, setUserTimeZone] = useState(parseTimeZone(profile.TimeZone))

    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const allRemarks = useSelector((state) => state.visitsReducer.remarks) || {}

    const visitIdValue = useRef('')

    const { remarksList = [] } = allRemarks[visitIdValue.current] || {}

    useEffect(() => {
      setUserTimeZone(parseTimeZone(profile.TimeZone))
    }, [profile])

    const closeRemarks = useCallback(() => {
      setShowRemarks(false)
    }, [setShowRemarks])

    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    const onClickRemarks = useCallback(({ target }) => {
      visitIdValue.current = target.dataset?.id

      if (remarksList) {
        remarksList.length = 0
      }

      if (!showRemarks) {
        setShowRemarks(true)
      }

      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getRemarks(visitIdValue.current))
    }, [])
    const tableMinWidth = visitsMode === 'Past' ? '1780px' : '2127px'

    return (
      <section className='visits-table' role='table' style={{ minWidth: tableMinWidth }}>
        {showRemarks ?
          <VisitRemarks
            visitId={visitIdValue.current}
            remarksList={remarksList}
            loading={loading}
            close={closeRemarks}
            userTimeZone={userTimeZone}
          />
        : null}
        <VisitsTableHeader
          // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
          visitTypesFilterRow={visitTypesFilterRow}
          statusFilterRow={statusFilterRow}
          closeRemarks={closeRemarks}
          visitsMode={visitsMode}
          stateFilter={stateFilter}
          dispatchFilter={dispatchFilter}
          setVisitTypesFilterRow={setVisitTypesFilterRow}
          setStatusFilterRow={setStatusFilterRow}
          tagFilterRow={tagFilterRow}
          setStatusTagRow={setStatusTagRow}
          isNeedToUpdateFilterIcon={isNeedToUpdateFilterIcon}
        />
        {visits?.length && !loading ?
          <VisitsTableContainer
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            setTriggerTabId={setTriggerTabId}
            setSelectedVisitId={setSelectedVisitId}
            visits={visits}
            onClickRemarks={onClickRemarks}
            visitsMode={visitsMode}
            timeZone={stateFilter.timeZone}
          />
        : <div className='visits-no-results'>{noResults}</div>}
      </section>
    )
  },
)
